import _ from 'lodash';

import { getCommonFields } from '_/components/Dashboard/Widgets/DashboardWidgets.commonFields.js';

export const getFields = (WeeklyChartWidget) => {
    const commonFields = getCommonFields(WeeklyChartWidget);

    const fields = [
        ...commonFields,

        {
            id: WeeklyChartWidget.widget.id + '|chart_period',
            inline: false,
            label: 'Period',
            mutation: 'widget/UPDATE_WIDGET_PROPERTY',
            name: WeeklyChartWidget.widget.id + '|chart_period',
            optionsData: [
                {
                    id: 'this-week',
                    text: 'This week',
                },
                {
                    id: 'last-week',
                    text: 'Last week',
                },
                {
                    id: 'last-seven-days',
                    text: 'Last 7 days',
                },
            ],
            preselectFirst: true,
            relatedTableName: false,
            required: true,
            tooltip: 'Weekly chart time interval.',
            value: _.has(WeeklyChartWidget.metaData, 'chart_period') ? WeeklyChartWidget.metaData.chart_period : null,
            vueComponent: 'Relationship',
        },

        {
            id: WeeklyChartWidget.widget.id + '|refresh_interval',
            inline: false,
            label: 'Data Refresh Interval',
            mutation: 'widget/UPDATE_WIDGET_PROPERTY',
            name: WeeklyChartWidget.widget.id + '|refresh_interval',
            disabled: true,
            optionsData: [
                {
                    id: 10 * 60 * 1000,
                    text: 'Every 10 minutes',
                },
            ],
            relatedTableName: false,
            required: true,
            tooltip: 'Widget data refresh interval.',
            value: '600000',
            vueComponent: 'Relationship',
        },
    ];

    return fields;
};
